import { render, staticRenderFns } from "./dragBtn.vue?vue&type=template&id=b143c15a&scoped=true"
import script from "./dragBtn.vue?vue&type=script&lang=js"
export * from "./dragBtn.vue?vue&type=script&lang=js"
import style0 from "./dragBtn.vue?vue&type=style&index=0&id=b143c15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143c15a",
  null
  
)

export default component.exports